import { useEffect } from 'react'
import { useOptimizelyVariant } from 'src/lib/optimizely/optimizely-variant'
import { BlogTag } from '@/components/BlogTags/mapBlogTag'
import { BlogTagsExperiment } from 'src/utils/blog/blog-utils'

// One instance is rendered per experiment, so useOptimizelyVariant is called
// exactly once per component — the rules of hooks are satisfied without an
// eslint-disable. Calling the hook here also fires the ExperienceImpression
// for this flag (via useSpecificOptimizelyUserDecision). The component renders
// nothing; it reports the resolved variant tags back to the parent.
export const ExperimentTagsResolver = ({
  experiment,
  onResolved,
}: {
  experiment: BlogTagsExperiment
  onResolved: (flagKey: string, tags: BlogTag[]) => void
}): null => {
  const tags = useOptimizelyVariant<BlogTag[]>(experiment)
  useEffect(() => {
    if (tags?.length) onResolved(experiment.flagKey, tags)
  }, [tags, experiment.flagKey, onResolved])
  return null
}
